import React from 'react';
import { SectionHeader, CornerBrackets, FadeIn } from '../ui';
export function Difference() {
  const pillars = [{
    title: 'Quality construction',
    desc: 'Built to exacting standards with premium materials.'
  }, {
    title: 'Attention to detail',
    desc: 'Meticulous finishing touches that define luxury.'
  }, {
    title: 'Personalised service',
    desc: 'A tailored approach to your unique lifestyle.'
  }, {
    title: 'Transparent communication',
    desc: 'Clear updates and no surprises throughout the build.'
  }, {
    title: 'In-house design guidance',
    desc: 'Expert architectural and interior design support.'
  }, {
    title: 'Direct director access',
    desc: 'Hands-on involvement from the Marcolina family.'
  }, {
    title: 'Long-term trades',
    desc: 'Consistent craftsmanship from trusted partners.'
  }, {
    title: 'Family legacy',
    desc: 'Three generations of Perth building excellence.'
  }];
  return <section className="py-16 md:py-24 bg-atrium-ivory" data-id="element-134">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-135">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24" data-id="element-136">
          {/* Sticky Header Column */}
          <div className="w-full lg:w-1/3" data-id="element-137">
            <div className="sticky top-32" data-id="element-138">
              <FadeIn data-id="element-139">
                <SectionHeader eyebrow="Why Atrium" title="Why discerning Perth homeowners choose Atrium" data-id="element-140" />
              </FadeIn>
            </div>
          </div>

          {/* Grid Column */}
          <div className="w-full lg:w-2/3" data-id="element-141">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8" data-id="element-142">
              {pillars.map((pillar, index) => <FadeIn key={index} delay={index % 2 * 100} data-id="element-143">
                  <div className="relative p-8 bg-white shadow-diffuse group hover:shadow-diffuse-lg transition-editorial duration-600 h-full" data-id="element-144">
                    <CornerBrackets color="bronze" data-id="element-145" />
                    <h3 className="font-serif text-xl text-atrium-ink mb-3 group-hover:text-atrium-green transition-colors" data-id="element-146">
                      {pillar.title}
                    </h3>
                    <p className="text-sm text-atrium-ink/70 leading-relaxed" data-id="element-147">
                      {pillar.desc}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}